/** Reference row: Lunatik 10.00 KM → Sosline by stanje (1–5). */
const LUNATIK_REFERENCE_KM = 10;

const SOSLINE_AT_REFERENCE: Record<number, number> = {
  1: 5,
  2: 4,
  3: 3.5,
  4: 3,
  5: 2.5,
};

/**
 * Sosline prodajna cijena (KM) from Lunatik prodajna cijena and condition 1–5.
 * Scales linearly from the 10 KM reference table.
 */
export function soslinePriceFromLunatik(lunatikKm: number, condition: number): number | null {
  if (!Number.isFinite(lunatikKm) || lunatikKm < 0) return null;
  const atRef = SOSLINE_AT_REFERENCE[condition];
  if (atRef == null) return null;
  return Math.round((lunatikKm / LUNATIK_REFERENCE_KM) * atRef * 100) / 100;
}

export function allSoslineFromLunatik(lunatikKm: number): Array<{ condition: number; km: number }> | null {
  if (!Number.isFinite(lunatikKm) || lunatikKm < 0) return null;
  return [1, 2, 3, 4, 5].map((c) => ({
    condition: c,
    km: (lunatikKm / LUNATIK_REFERENCE_KM) * SOSLINE_AT_REFERENCE[c],
  })).map((r) => ({ ...r, km: Math.round(r.km * 100) / 100 }));
}
